export default __webpack_public_path__ + "static/media/scroll-to-top-icon.c5ffc34b.svg";